import { defineMessages, useIntl } from 'react-intl';

import { Text } from '~/eds/src/components/Text/Text';
import type { Task as TaskType } from '~/redux/api/methods/k2/listTasks';

import { Task } from './Task';
import { TaskLoading } from './Task.loading';

const messages = defineMessages({
  noTasks: {
    id: 'StageTasks.noTasks',
    defaultMessage: 'No tasks',
    description: 'Empty state when a stage has no tasks',
  },
});

type Props = {
  tasks: TaskType[];
  isLoading: boolean;
};

export const StageTasks = ({ tasks, isLoading }: Props) => {
  const intl = useIntl();

  if (isLoading) {
    return (
      <>
        <TaskLoading />
        <TaskLoading />
        <TaskLoading />
      </>
    );
  }

  if (tasks.length === 0) {
    return (
      <Text variant="body-medium" color="text.secondary">
        {intl.formatMessage(messages.noTasks)}
      </Text>
    );
  }

  return (
    <>
      {tasks.map((task) => (
        <Task key={task.id} task={task} />
      ))}
    </>
  );
};
